import { delay, merge, Observable, OperatorFunction, pipe } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  throttleTime,
} from 'rxjs/operators';
import { skipForUnauthenticatedUsers } from '../../auth/utils';
import {
  DocumentSnapshot,
  firestore,
  QuerySnapshot,
} from '../../firebase/firebaseAccess';
import { createObservableQuery } from '../../firebase/rxfireExtensions';

const delayUntilApiServerMayReceivedTheChanging = <T>(): OperatorFunction<
  QuerySnapshot<T>,
  DocumentSnapshot<T>[]
> =>
  pipe(
    filter(querySnap => !querySnap.metadata.hasPendingWrites),
    map(querySnap => querySnap.docs),
    delay(1000),
  );

// for coupon.onlyNewUser, coupon.onlyPurchasedUser, coupon.onlyNewUserPerStore
const latestOrderId$ = skipForUnauthenticatedUsers(
  currentUserId =>
    createObservableQuery(
      firestore()
        .collection('orders')
        .where('buyerId', '==', currentUserId)
        .limit(1),
      delayUntilApiServerMayReceivedTheChanging(),
    )().pipe(map(orders => orders.docs[0]?.id ?? null)),
  null,
).pipe(distinctUntilChanged());

// for coupon.onlyFollower
const latestFollowingUserId$ = skipForUnauthenticatedUsers(
  currentUserId =>
    createObservableQuery(
      firestore()
        .collection('profiles')
        .doc(currentUserId)
        .collection('followings')
        .orderBy('timestamp', 'desc')
        .limit(1),
      delayUntilApiServerMayReceivedTheChanging(),
    )().pipe(map(followings => followings.docs[0]?.id ?? null)),
  null,
).pipe(distinctUntilChanged());

const myCouponCount$ = skipForUnauthenticatedUsers(
  currentUserId =>
    createObservableQuery(
      firestore()
        .collection('redeemedCoupons')
        .where('buyerId', '==', currentUserId),
      delayUntilApiServerMayReceivedTheChanging(),
    )(),
  {
    docs: [],
    querySnapshot: null as any,
  },
).pipe(
  map(coupons => coupons.docs.length),
  distinctUntilChanged(),
);

const onlyTriggerOnceInOneTask = throttleTime(0);
export const relatedCouponsMayChanged$: Observable<void> = merge(
  latestOrderId$,
  latestFollowingUserId$,
  myCouponCount$,
).pipe(
  onlyTriggerOnceInOneTask,
  map(() => {}),
);
